import React from 'react';

const Cookies = () => {
  return (
    <div className="cookies-page overflow-x-clip">
      <section className="section bg-white">
        <div className="container mx-auto px-4 sm:px-5 max-w-4xl min-w-0">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-8 text-brand-dark-blue break-words">
            Cookies
          </h1>

          <p className="text-lg text-gray-700 mb-6 leading-relaxed">
            Tento web používa súbory cookies na zabezpečenie správnej funkčnosti,
            meranie návštevnosti a zlepšovanie používateľského zážitku.
          </p>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Čo sú cookies</h2>
              <p>
                Cookies sú malé textové súbory, ktoré sa ukladajú vo vašom zariadení
                pri návšteve webovej stránky. Umožňujú webu zapamätať si vaše nastavenia
                alebo zlepšiť jeho fungovanie.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Aké cookies používame</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Nezbytné cookies</strong> – potrebné na správne fungovanie webu.</li>
                <li><strong>Analytické cookies</strong> – pomáhajú zlepšovať obsah a funkcie webu.</li>
                <li><strong>Marketingové cookies</strong> – používajú sa na relevantnú komunikáciu (len so súhlasom).</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Súhlas a nastavenie</h2>
              <p>
                Používanie cookies môžete kedykoľvek upraviť vo vašom prehliadači.
                Zablokovanie niektorých cookies môže ovplyvniť funkčnosť webu.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Ako cookies vymazať</h2>
              <p>
                Nastavenia prehliadača umožňujú cookies vymazať alebo zakázať.
                Konkrétny postup závisí od vášho prehliadača.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand-dark-blue mb-2">Zmeny v zásadách</h2>
              <p>
                Zásady používania cookies môžu byť priebežne aktualizované.
                Odporúčame preto občasnú kontrolu tejto stránky.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cookies;
